// src/ui/client/btn/ThemeSwitcherNav.tsx
'use client';
import { useEffect, useState } from 'react';

import styles from './ThemeSwitcherNav.module.css';

const ThemeSwitcher = () => {
  const [theme, setTheme] = useState<string | null>(null); // Initialisation avec `null` pour gérer l'état chargé

  useEffect(() => {
    // Récupérer le thème initial depuis le cookie ou les préférences système
    const savedTheme = document.cookie
      .split('; ')
      .find((row) => row.startsWith('theme='))
      ?.split('=')[1];

    const systemTheme = window.matchMedia('(prefers-color-scheme: dark)').matches ? 'dark' : 'light';

    // Utiliser le thème du cookie ou celui du système
    const initialTheme = savedTheme || systemTheme;
    setTheme(initialTheme);
    document.documentElement.className = `theme-${initialTheme}`;

    // Observer les changements de classe pour synchroniser le thème
    const observer = new MutationObserver(() => {
      const updatedTheme = document.documentElement.className.includes('theme-dark') ? 'dark' : 'light';
      setTheme(updatedTheme);
    });

    observer.observe(document.documentElement, { attributes: true, attributeFilter: ['class'] });

    return () => observer.disconnect();
  }, []);

  const toggleTheme = () => {
    const newTheme = theme === 'dark' ? 'light' : 'dark';
    setTheme(newTheme);
    document.documentElement.className = `theme-${newTheme}`;
    document.cookie = `theme=${newTheme}; path=/; max-age=31536000`; // Sauvegarder dans les cookies
  };

  if (!theme) {
    // Afficher un état de chargement si le thème n'est pas encore déterminé
    return null;
  }

  return (
    <button onClick={toggleTheme} className={`${styles.switcher} ${theme === 'dark' ? styles.dark : styles.light}`} aria-label={`Activer le mode ${theme === 'dark' ? 'clair' : 'sombre'}`}>
      {theme === 'dark' ? '🌙' : '🌞'}
    </button>
  );
};

export default ThemeSwitcher;
